const loadURLProds = (steps, products, setSteps, fetchProd, searchParams, setSearchParams) => {
    steps.forEach(async step => {
        let isSelected = searchParams.get(step.tag);

        if(!isSelected) {
            searchParams.delete(step.tag);
            return setSearchParams(searchParams, { replace: true });
        }

        let amount = 1;

        if(isSelected.includes(',')) {
            amount = isSelected.split(',').length;

            isSelected = isSelected.split(',')[0];
        }

        isSelected = Number(isSelected);

        if(!alreadyFetched(step.category_id, products)) {
            let selectedProd = await fetchProd(isSelected);

            if(selectedProd.error) {
                searchParams.delete(step.tag);
                return setSearchParams(searchParams, { replace: true });
            }

            if(!belongsToCategory(step.category_id, selectedProd)) {
                searchParams.delete(step.tag);
                return setSearchParams(searchParams, { replace: true });
            }

            setSteps(prevSteps => 
                prevSteps.map(prevstep => prevstep.id === step.id ? {...prevstep, data: {...selectedProd, cantidad: amount}} : prevstep)
            )
        } else {
            setSteps(prevSteps => 
                prevSteps.map(prevstep => prevstep.id === step.id ? {...prevstep, data: {...products.find(prods => prods.id === step.category_id).data.find(prod => prod.id === isSelected), cantidad: amount}} : prevstep)
            )
        }
    })
}

// category_id de un step puede ser un slug (string) o varios (array de strings)
const getStepSlugs = (category_id) => Array.isArray(category_id) ? category_id : [category_id];

// Ya se cargaron (fetch) los productos de la/s categoria/s de este step?
const alreadyFetched = (category_id, products) => {
    return products.some(p => JSON.stringify(p.id) === JSON.stringify(category_id));
}

// El producto (traido por ID) pertenece a alguna de las categorias configuradas en el step?
// WooCommerce devuelve product.categories = [{ id, name, slug }, ...]
const belongsToCategory = (category_id, product) => {
    if(!product?.categories) return false;

    const stepSlugs = getStepSlugs(category_id);

    return product.categories.some(cat => stepSlugs.includes(cat.slug));
}

export default loadURLProds;